import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "21",
  viewBox: "0 0 16 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.63928 5.59042V1.98605C3.63928 1.71747 3.85676 1.5 4.12533 1.5H11.9306C12.1992 1.5 12.4167 1.71747 12.4167 1.98605V5.59042",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.14 6.73581C15.14 6.103 14.6272 5.59021 13.9944 5.59021H2.1456C1.51279 5.59021 1 6.103 1 6.73581V18.6185C1 19.2513 1.51279 19.7641 2.1456 19.7641H13.9944C14.6272 19.7641 15.14 19.2513 15.14 18.6185V6.73581Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.4913 12.7023C10.4913 14.1345 9.33002 15.2957 7.89785 15.2957C6.46569 15.2957 5.30444 14.1349 5.30444 12.7023C5.30444 11.2697 6.46569 10.1089 7.89785 10.1089C9.33002 10.1089 10.4913 11.2697 10.4913 12.7023Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }